<section class="notFound innerContainer">
  <vc-images
    [imgSrcSet]="[
      {width: '320', height: '160', otherParams: '&ar=2:1', descriptor: '320w'},
      {width: '375', height: '188', otherParams: '&ar=2:1', descriptor: '375w'},
      {width: '414', height: '207', otherParams: '&ar=2:1', descriptor: '414w'},
      {width: '576', height: '480', otherParams: '&ar=6:5'}
    ]"
    sizes="(min-width: 1024px) 576px, 100vw"
    [url]="errorImgPath"
    class="notFound__img"
    width="576"
    height="480"
    alt=" "
  ></vc-images>

  <div class="notFound__info">
    <h2 class="notFound__info__title vc-title-m">
      <span *ngIf="statusCode === 404; else defaultMessage" i18n="@@NOT_FOUND.TITLE.404">
        Sorry, we couldn't find this page.
      </span>
      <ng-template #defaultMessage i18n="@@NOT_FOUND.TITLE.DEFAULT">Oops, this page isn't available</ng-template>
    </h2>
    <div class="notFound__info__actions">
      <vc-ref
        class="notFound__info__actions__btn"
        extraClass="vc-btn vc-btn--large vc-btn--primary"
        i18n-resource="@@NOT_FOUND.BUTTON_WOMEN.LINK"
        resource="/women/"
        i18n="@@NOT_FOUND.BUTTON_WOMEN.NAME"
        >Women</vc-ref
      >
      <vc-ref
        class="notFound__info__actions__btn"
        extraClass="vc-btn vc-btn--large vc-btn--primary"
        i18n-resource="@@NOT_FOUND.BUTTON_MEN.LINK"
        resource="/men/"
        i18n="@@NOT_FOUND.BUTTON_MEN.NAME"
        >Men</vc-ref
      >
    </div>
    <vc-ref class="notFound__info__link" extraClass="vc-link" [routerLink]="''" i18n="@@NOT_FOUND.LINK_BACK_HOME">
      Back to homepage
    </vc-ref>
  </div>
</section>
